// AttributeSearch.ts
import { HttpParams }   from '@angular/common/http';

export default class AttributeSearch {
    id                        : Number = null;
    model_name                : string = null;
    instance_id               : Number = null;
    code                      : string = null;
    
    specification             : string[] = [];

    constructor()
    {
    }

    getHttpParams()
    {
      var params = new HttpParams({});
      if (this.id               !== null) { params = params.set('id', this.id.toString()); }
      if (this.model_name       !== null) { params = params.set('model_name', this.model_name.toString()); }
      if (this.instance_id      !== null) { params = params.set('instance_id', this.instance_id.toString()); }
      if (this.code             !== null) { params = params.set('code', this.code.toString()); }
      if (this.specification !== undefined && this.specification.length == 2) { params = params.set('specification', JSON.stringify(this.specification)); }
      

      return params;
    }

  }
